import { ArticleHeading3, ArticleHeading5 } from '@cian/ui-kit';

import { FC } from 'react';

import styles from './AveragePriceSEOBlock.css';

type AveragePriceSEOBlockProps = {
  averagePrice: string;
};

export const AveragePriceSEOBlock: FC<AveragePriceSEOBlockProps> = props => {
  const { averagePrice } = props;

  return (
    <div className={styles['container']}>
      <ArticleHeading5>Средняя цена</ArticleHeading5>
      <ArticleHeading3>{averagePrice}</ArticleHeading3>
    </div>
  );
};
